import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mergingfacility-dnto-matrix',
  templateUrl: './mergingfacility-dnto-matrix.component.html',
  styleUrls: ['./mergingfacility-dnto-matrix.component.css']
})
export class MergingfacilityDntoMatrixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
